var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 5,
    fill: "#FF5500"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3366_44346)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.25 13.25V10.1123C20.25 9.88016 20.1579 9.65785 19.9938 9.49352L18.7562 8.25621C18.5921 8.09215 18.3696 8 18.1374 8H10.625C10.1418 8 9.75 8.39184 9.75 8.875V13.25C8.7834 13.25 8 14.0334 8 15V18.0625C8 18.3042 8.19578 18.5 8.4375 18.5H9.75V21.125C9.75 21.6082 10.1418 22 10.625 22H19.375C19.8582 22 20.25 21.6082 20.25 21.125V18.5H21.5625C21.8042 18.5 22 18.3042 22 18.0625V15C22 14.0334 21.2166 13.25 20.25 13.25ZM18.5 20.25H11.5V17.625H18.5V20.25ZM18.5 14.125H11.5V9.75H16.75V11.0625C16.75 11.3042 16.9458 11.5 17.1875 11.5H18.5V14.125ZM19.8125 16.0938C19.4502 16.0938 19.1562 15.7998 19.1562 15.4375C19.1562 15.0749 19.4502 14.7812 19.8125 14.7812C20.1748 14.7812 20.4688 15.0749 20.4688 15.4375C20.4688 15.7998 20.1748 16.0938 19.8125 16.0938Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3366_44346"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreen);
export default __webpack_public_path__ + "static/media/screen.16011631946b3fbb8329cac0f7080800.svg";
export { ForwardRef as ReactComponent };